import React from 'react';
import AddIcon from '@atlaskit/icon/glyph/add';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import Button from '@atlaskit/button/standard-button';
import { LoadingIndicator } from '@atlassian/temp-loading-indicator';
import { CartSearchCustomer } from './search-customer';
import { CompanyName } from './common';
import { CartCustomerSearchItem } from '../types';
import { AddCustomerModal } from './add-customer-modal';

interface Props {
  onSelect: (selected: CartCustomerSearchItem) => void;
  onSearch: (selected: string) => void;
  isLoading?: boolean;
  searchList?: CartCustomerSearchItem[];
  onAddCustomerClick?: () => void;
}

export const CustomerSelect = ({
  onSelect,
  onSearch,
  searchList = [],
  isLoading = false,
  onAddCustomerClick,
}: Props) => {
  return (
    <div className="ppc-customer-select flex justify-space-between align-center">
      <CompanyName />
      <DropdownMenu
        trigger={<Button iconBefore={<AddIcon label="add-customer" />} />}
        position="bottom right"
        defaultOpen={true}
      >
        <CartSearchCustomer className="pa-16" onSearch={onSearch} />
        {onAddCustomerClick ? (
          <Button appearance="link" onClick={onAddCustomerClick}>
            + Create Customer
          </Button>
        ) : null}

        {isLoading ? (
          <LoadingIndicator size="medium" />
        ) : (
          <DropdownItemGroup>
            {searchList.map((searchItem: CartCustomerSearchItem) => {
              return (
                <DropdownItem key={searchItem.name} onClick={() => onSelect(searchItem)}>
                  {searchItem.name}
                </DropdownItem>
              );
            })}
          </DropdownItemGroup>
        )}
      </DropdownMenu>
    </div>
  );
};
